/** Shown instead of the app when /config.json can't be loaded (src/bootstrap.tsx). */
export function ConfigErrorScreen() {
  return (
    <div className="login-page" role="alert" data-testid="config-error">
      <div className="login-card">
        <h2>The chat assistant is unavailable</h2>
        <p>Configuration could not be loaded. Please refresh the page in a moment.</p>
      </div>
    </div>
  );
}
